import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Container, Divider, Spacer, Typography } from '@emburse/embark-core';
import EmployeeMappingTable from './EmployeeMappingTable';
import BulkEditDrawer from './BulkEditDrawer';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
import { generateRandomGUID } from '../../../../util/helpers';
import { getSetupData } from '../../../../api/SSI';
import { StepType } from '../../../../interfaces/SSI';
const EmployeeMapping = forwardRef(({ data, loading }, ref) => {
    useTranslation();
    const [tableData, setTableData] = useState([]);
    useEffect(() => setTableData(data || []), [data]);
    useImperativeHandle(ref, () => ({
        getData() {
            return tableData;
        }
    }));
    const [empGLDs, setEmpGLDs] = useState([]);
    // unsure if we should be connecting to the QuickSetup loading prop for this, but was having issues with hitting items before load
    const [isLoading, setIsLoading] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    useEffect(() => {
        if (!empGLDs.length) {
            getSetupData(StepType.EmployeeDimensions).then((resp) => {
                let parsedData = JSON.parse(JSON.parse(resp.Data));
                if (Array.isArray(parsedData)) {
                    parsedData = parsedData.map((row) => ({ ...row, id: generateRandomGUID() }));
                }
                setEmpGLDs(parsedData);
                setIsLoading(false);
            });
        }
    }, [empGLDs]);
    const removalCheck = (newValue, existingValue) => {
        if (newValue || newValue === 0) {
            return newValue === 0 ? 0 : newValue;
        }
        return existingValue;
    };
    const handleBulkGLDSave = (values) => {
        if (selectedUsers.length > 0) {
            for (let i = 0; i < selectedUsers.length; i += 1) {
                setTableData((prevstate) => prevstate.map((tRow) => {
                    if (tRow.id === selectedUsers[i]) {
                        const updatedValues = {
                            ...tRow,
                            GLD1PK: removalCheck(values[0], tRow.GLD1PK),
                            GLD2PK: removalCheck(values[1], tRow.GLD2PK),
                            GLD3PK: removalCheck(values[2], tRow.GLD3PK),
                            GLD4PK: removalCheck(values[3], tRow.GLD3PK),
                            GLD5PK: removalCheck(values[4], tRow.GLD5PK)
                        };
                        return updatedValues;
                    }
                    return tRow;
                }));
            }
        }
    };
    const rowChangeHandler = (row) => setTableData((prevState) => prevState.map((tRow) => (tRow.id === row.id ? row : tRow)));
    const hasActiveEmpGLD = () => empGLDs.some((empGLD) => empGLD.Label.length > 0);
    return (_jsxs(Container, { disableGutters: true, children: [!isLoading && (_jsx(BulkEditDrawer, { showDrawer: showDrawer, onSetShowDrawer: setShowDrawer, empGLDData: empGLDs, selectedUsers: selectedUsers.length, handleBulkGLDSave: handleBulkGLDSave })), _jsx(Typography, { variant: "h4", children: $t('Map Users to Employee General Ledger Dimensions') }), _jsx(Spacer, { size: 10 }), hasActiveEmpGLD() && (_jsxs(_Fragment, { children: [_jsx(Typography, { children: $t(`Now that you've uploaded your Employee GLDs to the system, assign them to your users below. 
                You can use the 'Bulk Edit' button on the right to assign multiple users to the same GLD values.`) }), _jsx(Spacer, { size: 10 }), _jsx(Typography, { children: $t('All users do not need to be assigned Employee GLDs.') }), _jsx(Spacer, { size: 35 }), _jsx(Divider, { orientation: "horizontal", variant: "fullWidth", style: { width: '100%' }, light: true }), _jsx(Spacer, { size: 35 }), !isLoading && (_jsx(EmployeeMappingTable, { tableData: tableData, empGLDs: empGLDs, selectedUsers: selectedUsers, setSelectedUsers: setSelectedUsers, onSetShowDrawer: setShowDrawer, rowChangeHandler: rowChangeHandler, loading: loading }))] })), !hasActiveEmpGLD() && (_jsxs(_Fragment, { children: [_jsx(Typography, { children: $t('No Employee General Ledger Dimensions are active at this time. You may proceed to the next step.') }), _jsx(Typography, { children: $t("Don't worry, you can always add Employee GLDs later.") })] }))] }));
});
export default EmployeeMapping;
